/**
 * ProfileRpcClient - AtomRpc integration for profile/layer/config-log endpoints.
 *
 * Read/mutate endpoints (listLayers, getLayer, upsertLayer, renderProfile,
 * listConfigLog, listHourlyTags) are gated by Clerk auth via `AuthMiddleware`.
 * `appendConfigLog` is gated by `MgmtAgentMiddleware`; the operator UI calls
 * it to log rollback intent, but the actual rollback is applied manually via
 * SSH for now (v1).
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { ProfileRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer, MgmtAgentMiddlewareClientLive } from "./shared.ts";

export class ProfileRpcClient extends AtomRpc.Tag<ProfileRpcClient>()(
  "ProfileRpcClient",
  {
    group: ProfileRpcs,
    protocol: Layer.merge(
      makeRpcClientLayer(ProfileRpcs),
      MgmtAgentMiddlewareClientLive,
    ).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
